import {css, CSSProperties, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Checkbox from 'ui-library/Checkbox';
import {GRAY_DARK} from 'ui-library/Colors';

export interface DataFrameTableIndexCellProps {
  index: number;
  minWidth: CSSProperties['minWidth'];
  showCheckbox: boolean;
  isCheckboxSelected: boolean;
}

function DataFrameTableIndexCellContents(props: DataFrameTableIndexCellProps): JSX.Element {
  return (
    <div
      style={{minWidth: props.minWidth}}
      {...getTestProps({component: 'DataFrameTableIndexCellContents', element: 'root'})}
    >
      {props.showCheckbox ? (
        <Checkbox checked={props.isCheckboxSelected} />
      ) : (
        <span className={css(styles.indexCell)}>{props.index}</span>
      )}
    </div>
  );
}

export default React.memo(DataFrameTableIndexCellContents);

const styles = StyleSheet.create({
  indexCell: {
    color: GRAY_DARK,
  },
});
